module.exports = __webpack_public_path__ + "static/spotify-podcast-badge-blk-grn-165x40-d54f4c8ac147aa38786e855dd4b44404.svg";